export const _initialState = {
  disabled: null,
  choicesInfo: null,
  violatingSegments: {},
  compatibilitySegments: {},
  compatibilityHeights: {},
  enabledSizes: []
};
